import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
import { GALLERY_PHOTOS, GALLERY_REELS } from '../data/site';
export function Gallery() {
  return <section id="gallery" className="w-full bg-ink py-16 sm:py-24" data-id="element-92" data-mp="3ibzcz519lzf4">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-93" data-mp="3ia52ylrj7rpt">
        <div className="max-w-2xl" data-id="element-94" data-mp="3de6aalz67njl">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-brand-orange" data-id="element-95" data-mp="3ddxyyyip4qai">
            Inside the academy
          </span>
          <h2 className="mt-3 text-3xl uppercase sm:text-4xl" data-id="element-96" data-mp="2kozbdlvt0vxt">Training in action</h2>
          <p className="mt-4 text-white/70" data-id="element-97" data-mp="2zd3li1gsjz4z">
            Real sessions at Juniper Valley Park — technical work, small-sided games, and match
            preparation.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3" data-id="element-98" data-mp="26x2n5sx9b66p">
          {GALLERY_PHOTOS.map((photo, index) => <motion.figure key={photo.src} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.06
        }} className="overflow-hidden rounded-2xl border border-ink-line bg-ink-card" data-id="element-99" data-mp="21yralafkuhks" data-mpi={index}>
              <img src={photo.src} alt={photo.alt} className="h-full w-full aspect-[4/5] object-cover object-center transition-transform duration-500 hover:scale-105" loading="lazy" data-id="element-100" data-mp="153ptqoekfary" />
            </motion.figure>)}
        </div>

        <h3 className="mt-14 font-display text-xl uppercase tracking-wide" data-id="element-101" data-mp="he3vq49xj1lj">Session reels</h3>
        <div className="mt-5 grid grid-cols-1 gap-6 sm:grid-cols-3" data-id="element-102" data-mp="mdzr5f4k9kph">
          {GALLERY_REELS.map((reel, index) => <motion.figure key={reel.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="group relative overflow-hidden rounded-[15px] border border-ink-line bg-ink-card shadow-lg shadow-black/50" data-id="element-103" data-mp="1ssikm6gbysfp" data-mpi={index}>
              {reel.videoUrl ? <video src={reel.videoUrl} poster={reel.poster} controls playsInline preload="none" aria-label={reel.alt} className="h-full w-full aspect-[9/16] bg-black object-cover" data-id="element-104" data-mp="2pguloumxisu" /> : <>
                  <img src={reel.poster} alt={reel.alt} className="h-full w-full aspect-[9/16] object-cover object-center transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-105" data-mp="3kwegqcsr52s2" />
                  <span className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" data-id="element-106" data-mp="2nf673v7v8sid" />
                  <span className="absolute inset-0 flex items-center justify-center" data-id="element-107" data-mp="12vkd5iuicug2">
                    <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-brand-orange to-brand-red shadow-xl shadow-black/40 transition-transform group-hover:scale-110" data-id="element-108" data-mp="17pojbzvy8yg3">
                      <PlayIcon className="h-6 w-6 translate-x-[1px] text-white" aria-hidden="true" data-id="element-109" data-mp="xw7oqtnznfbd" />
                    </span>
                  </span>
                </>}
              <figcaption className={reel.videoUrl ? 'flex items-center justify-between gap-2 px-4 py-3' : 'pointer-events-none absolute bottom-0 left-0 right-0 flex items-center justify-between gap-2 p-4'} data-id="element-110" data-mp="1cmopsbwpo37q">
                <span className="text-sm font-bold uppercase tracking-wide drop-shadow" data-id="element-111" data-mp="68z4mpzjtt1r">
                  {reel.title}
                </span>
                <span className="rounded-full bg-white/15 px-2 py-0.5 text-[11px] font-semibold text-white/85" data-id="element-112" data-mp="gqkwte2kbr8t">
                  {reel.duration}
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}